import mergeProps from "@store/Framework/Common/Utilities/mergeProps";
import FlexWrapper, { FlexWrapperProps, FlexWrapperStyles } from "@store/Library/Components/Toolkit/FlexWrapper";
import { spacingStyles } from "@store/Themes/common/mixins/spacing";
import React, { FC, useMemo } from "react";
import { useTheme } from "styled-components";

export interface TagWrapperProps extends FlexWrapperProps {
    showTopGap?: boolean;
    showBottomGap?: boolean;
    children?: React.ReactNode;
}

const TagWrapper: FC<TagWrapperProps> = ({
    children,
    gap: baseGap,
    showTopGap,
    showBottomGap,
    extendedStyles: baseExtendedStyles,
    ...props
}) => {
    const { tag } = useTheme();
    const gap = baseGap || tag.gap;

    const extendedStyles = useMemo(() => {
        if (showTopGap || showBottomGap) {
            return mergeProps<FlexWrapperStyles>(baseExtendedStyles, {
                wrapper: {
                    css: spacingStyles(showTopGap ? gap : null, showBottomGap ? gap : null),
                },
            });
        }

        return baseExtendedStyles;
    }, [showTopGap, showBottomGap, baseExtendedStyles]);

    return (
        <FlexWrapper gap={gap} {...props} extendedStyles={extendedStyles}>
            {children}
        </FlexWrapper>
    );
};

export default TagWrapper;
